import { cn } from '@/lib/utils'

function Skeleton({
  className,
  role = 'status',
  'aria-label': ariaLabel = 'Loading...',
  'aria-busy': ariaBusy = true,
  ...props
}: React.ComponentProps<'div'> & {
  role?: string
  'aria-label'?: string
  'aria-busy'?: boolean
}) {
  return (
    <div
      data-slot="skeleton"
      role={role}
      aria-label={ariaLabel}
      aria-busy={ariaBusy}
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

export { Skeleton }
